import { Color } from '../../../interface';
import { assignComponentProps } from '../../../utils/helpers';
import { getAppRoot } from '../../../utils/theme';
import { ModalOpts } from '../modal/modal-controller';

export interface VideoModalOpts extends ModalOpts {
  'color'?: Color;
  'mainTitle'?: string;
  'overlayIndex'?: number;
  'showBackdrop'?: boolean;
  'onLarmodalwillpresent'?:() => void,
  'onLarmodaldidpresent'?: () => void
  'onLarmodalwilldismiss'?: () => void,
  'onLarmodaldiddismiss'?: () => void,
}

export async function createVideoModal(opts: VideoModalOpts): Promise<HTMLLarVideoModalElement> {
  if (typeof customElements !== 'undefined') {
    await customElements.whenDefined('lar-video-modal');
    const element = document.createElement('lar-video-modal') as HTMLLarVideoModalElement;
    assignComponentProps(element, opts);
      // append the overlay element to the document body
    getAppRoot(document).appendChild(element);
    if (element.componentOnReady) {
      await element.componentOnReady();
    }
    element.addEventListener('larmodaldiddismiss', () => {
        element.remove();
      })
    return element;
  }
  throw new Error('WebComponents not available');
};
